import React, { useState } from 'react';
import { resolveCatalogueIntro } from '../../lib/catalogue-intro-context';
import { optimizedSrc, optimizedSrcSet } from '../../lib/image-cdn';
import '../../catalogue-intro.css';

export const CatalogueIntro = ({ scope = {}, titleTestId = 'catalogue-intro-title', summary, children }) => {
  const intro = resolveCatalogueIntro(scope);
  const [failed, setFailed] = useState(null);
  const source = failed === intro.image ? '/images/scenes/scene-lumipro-app-11.jpg' : intro.image;
  return <section className="catalogue-intro" data-testid="catalogue-intro" data-intro-kind={intro.kind}>
    <div className="catalogue-intro-media" data-testid="catalogue-intro-media">
      <img data-testid="catalogue-intro-image" src={optimizedSrc(source, { w: 1400 })}
        srcSet={optimizedSrcSet(source, [400, 800, 1400])} sizes="100vw" width="1600" height="640"
        alt={failed === intro.image ? 'Architectural interior with integrated linear lighting' : intro.alt} fetchPriority="high" decoding="async" onError={() => setFailed(intro.image)} />
      <div className="catalogue-intro-scrim" aria-hidden="true" />
      <div className="catalogue-intro-heading">
        <p className="catalogue-intro-context" data-testid="catalogue-intro-context">{intro.context}</p>
        <h1 data-testid={titleTestId}>{intro.title}</h1>
        {summary && <p className="catalogue-intro-summary" data-testid="catalog-hero-summary">{summary}</p>}
      </div>
      {intro.showCredit && <p className="catalogue-intro-credit" data-testid="catalogue-intro-imagery-note">{intro.credit}</p>}
    </div>
    <div className="catalogue-intro-copy">
      <p data-testid="catalogue-intro-description">{intro.text}</p>
      {children}
    </div>
  </section>;
};